module.exports = __webpack_public_path__ + "media/images/illustrations/online_quote_check-5abb78d54bf6faab1a23068300c60f0a.svg";